import {useRouter} from "vue-router";
import {getOpenIdApi} from "@/service"
import store from "@/store";
import customConfig from '/customConfig.js'
export const getOpenId = (cb) => {
    if(localStorage.getItem(customConfig.openIdName)){
        if(cb)cb();
        return false
    }
    const urlDecode=(url)=>{  //传入参数格式为url中"?"后面部分
        const path = url.split('?')[1]||'';
        const urlres= path.replace(/&/g, '","').replace(/=/g, '":"');
        const reqDataString = '{"' + urlres + '"}';
        const query = JSON.parse(reqDataString);
        return query
    }
    let code=''
    if(window.location.href.includes('?')){
        code=urlDecode(window.location.href).code||''
    }
    if (!code) {
        window.location.href = customConfig.authConfig.authorizationLink
    } else {
        getOpenIdApi({code}).then(res => {
            if(res.data.code==1){
                console.info('openid信息',res)
                localStorage.setItem(customConfig.userInfoName,res.data.data.user.openid)
                store.commit('setUserInfo',res.data.data.user)
                localStorage.setItem(customConfig.openIdName,res.data.data.user.openid)
                store.commit('setOpenid',res.data.data.user.openid)
                if(cb)cb();
            }
        })
            .catch(err => {
                console.error('获取openid错误信息',err)
            })
    }
}
